<template>
    <div class="podcast">
        <template v-if="isBackend">
             <podcast-player :podcast="podcast"/>
        </template>
        <template v-else>
            <public-layout :headless="embed">
                <podcast-player :podcast="podcast"
                                :show-download="show_download"
                                :show-start-project="show_start_project"
                                :sticky-at="embed ? 0 : 0"/>
            </public-layout>
        </template>
    </div>
</template>

<script>
import PublicLayout from "@/Layouts/PublicLayout";
import PodcastPlayer from "@/Components/Podcast/PodcastPlayer";
export default {
    name: "Show",
    components: {PodcastPlayer, PublicLayout},
    props: ['podcast', 'isBackend', 'embed', 'query_params'],


    computed: {
        show_download(){
            return typeof this.query_params?.download !== "undefined" ? !!parseInt(this.query_params?.download) : true;
        },
        show_start_project(){
            return typeof this.query_params?.start !== "undefined" ? !!parseInt(this.query_params?.start) : true;
        }
    },

    mounted() {
        this.setTitle( 'Podcast' );
    }

}
</script>

<style lang="scss" scoped>

</style>
